import { Component, OnInit, Input, } from '@angular/core';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertModal } from 'src/app/app.model';
import { IntegrationsService } from 'src/app/services/integrations.service';

@Component({
  selector: 'app-edit-integration',
  templateUrl: './edit-integration.component.html',
  styleUrls: ['./edit-integration.component.css']
})
export class EditIntegrationComponent implements OnInit {

  @Input() integration: any;
  integrationForm: FormGroup = this.formBuilder.group({});

  provider_fields: any[] = [];
  integration_settings: any[] = [];
  integrationName: any;
  loading: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private activeModalService: NgbActiveModal,
    private integrationService: IntegrationsService
  ) { }

  ngOnInit(): void {
    this.getIntegration();
  }

  getIntegration() {
    this.integrationService.getIntegration(this.integration.uuid)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.provider_fields = res.data.provider_fields;
          this.integrationName = res.data.provider;
          this.integration_settings = res.data.settings;
          this.buildForm();
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        }
      });
  }

  buildForm() {
    const group: any = {};
    console.log(this.provider_fields);
    this.provider_fields.forEach((field) => {
      group[field.key] = [
        this.integration_settings?.[field.key] || '',
        field.required ? Validators.required : [],
      ];
    });
    this.integrationForm = this.formBuilder.group(group);
  }

  onClose() {
    if (!this.hasValue && Object.keys(this.integrationForm.controls).length === 0) {
      this.activeModalService.close();
      return
    }

    const modalRef = this.modalService.open(AlertModalComponent, {
      size: 'md',
      backdrop: false,
      modalDialogClass: 'alert-modal modal-dialog-centered',
    });

    let data: AlertModal = {
      message: `Are you sure you want to discard updating ?`,
      yesAction: 'Discard',
      noAction: 'Cancel',
      yesActionColor: '#0566EA',
      noActionColor: 'transparent',
    }
    modalRef.componentInstance.data = data;
    modalRef.result.then((data) => {
      if (data?.action === 'yes') {
        this.activeModalService.close();
      }
    });
  }

  get hasValue() {
    let hasValue = false;
    Object.keys(this.integrationForm.value).forEach(element => {
      if (this.integrationForm.value[element]) {
        hasValue = true;
      }
    });
    return hasValue
  }

  onSubmit() {
    if (this.integrationForm.invalid) {
      this.integrationForm.markAllAsTouched();
      return;
    }
    const settings = this.integrationForm.value;
    this.integrationService.updateIntegrationSettings(this.integration.uuid, settings)
      .subscribe(res => {
        this.activeModalService.close({
          data: true,
        });
      })
  }

}
